import { styled, Box } from '../../../base';

export const MenuWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: theme.spacing(2),
}));

export const HeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 2, 0, 2),
}));

export const AccordionWrapper = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flex: 1,
}));

export const CandidateItemWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('background-color'),
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child': {
        borderBottom: 'none',
    },
}));

export const CandidateNameWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
}));

export const ScoreWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));

export const RangeBarWrapper = styled(Box)(({ theme }) => ({
    flex: 1,
    paddingInlineEnd: theme.spacing(1),
}));

export const StepHeaderWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));

export const StepNameWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(0.5),
}));
